import React, { memo } from 'react'
import { IDateRangePoint } from '../types'
import { getFormattedTimeRange } from '../utils/getFormattedTimeRange'

export interface IAppointmentTimeRangeProps {
  /**
   * @example { datetime: '2021-08-22T00:00:00.000Z', timezone: 'America/New_York' }
   */
  start: IDateRangePoint
  /**
   * @example { datetime: '2021-08-22T00:00:00.000Z', timezone: 'America/New_York' }
   */
  end?: IDateRangePoint
}

/**
 * Returns formatted date range string
 * @example
 * ```
 * <AppointmentTimeRange
 *   start={{
 *     datetime: START_AT,
 *     timezone: moment.tz.guess(),
 *   }}
 *   end={{
 *     datetime: END_AT,
 *     timezone: moment.tz.guess(),
 *   }}
 * />
 *```
 */
export const AppointmentTimeRange = memo<IAppointmentTimeRangeProps>(({ end, start }) => {
  const timeRange = getFormattedTimeRange({ startAt: start, endAt: end })
  return <span data-test='appointment-time-range'>{timeRange}</span>
})

export default AppointmentTimeRange
